import React from 'react';
import PropTypes from 'prop-types';
import { Box, HStack, Text, Link as CLink, Hide, useBreakpointValue } from '@chakra-ui/react';

const HeaderButtons = ({ label, link, iconChildren }) => {
  const showIcon = useBreakpointValue({ base: false, md: true, xl: false });
  return (
    <CLink _focus={{ boxShadow: 'none ' }} href={link} _hover={{ textDecoration: 'none' }}>
      <HStack
        px={5}
        variant="ghost"
        height={'44px'}
        color={'#a0a9b7'}
        fontSize={'12px'}
        _hover={{ bg: '#fff', color: '#11284B' }}
        _focus={{ boxShadow: 'none ' }}
      >
        <Box hidden={showIcon}>{iconChildren}</Box>
        <Hide below="md">
          <Text fontWeight={500}>{label}</Text>
        </Hide>
      </HStack>
    </CLink>
  );
};

HeaderButtons.propTypes = {
  label: PropTypes.string,
  link: PropTypes.string,
  iconChildren: PropTypes.any,
};

export default HeaderButtons;



// WEBPACK FOOTER //
// src/components/layout/HeaderButtons/HeaderButtons.jsx